import { useTranslation } from 'react-i18next';

export default function Pricing() {
  const { t } = useTranslation('home');

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 sm:mb-6 px-4">
            {t('pricing.title')}
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto px-4">
            {t('pricing.description')}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl shadow-2xl p-6 sm:p-8 md:p-12 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative z-10">
              <div className="text-center mb-8 sm:mb-10">
                <div className="inline-block bg-white/20 backdrop-blur-sm px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6 whitespace-nowrap">
                  {t('pricing.oneTimeOffer')}
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 sm:p-8 mb-4 sm:mb-6">
                  <div className="text-center">
                    <div className="text-4xl sm:text-5xl md:text-6xl font-bold mb-2">{t('pricing.freeNumbers')}</div>
                    <div className="text-2xl sm:text-3xl font-bold">{t('pricing.completelyFree')}</div>
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-base sm:text-lg opacity-90 mb-2">{t('pricing.thenOnly')}</div>
                  <div className="text-4xl sm:text-5xl font-bold mb-2">€3</div>
                  <div className="text-lg sm:text-xl opacity-90">{t('pricing.perNumber')}</div>
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-10">
                <div className="flex items-center gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl flex-shrink-0"></i>
                  <span className="text-sm sm:text-base">{t('pricing.features.noSubscription')}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl flex-shrink-0"></i>
                  <span className="text-sm sm:text-base">{t('pricing.features.noHiddenCosts')}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl flex-shrink-0"></i>
                  <span className="text-sm sm:text-base">{t('pricing.features.payAsYouGo')}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl flex-shrink-0"></i>
                  <span className="text-sm sm:text-base">{t('pricing.features.excelDelivery')}</span>
                </div>
              </div>

              <button
                onClick={scrollToContact}
                className="w-full bg-white text-teal-700 px-6 sm:px-8 md:px-12 py-4 sm:py-5 rounded-lg font-bold text-sm sm:text-base md:text-lg hover:bg-slate-100 transition-all hover:-translate-y-1 shadow-lg hover:shadow-xl cursor-pointer"
              >
                {t('pricing.ctaButton')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
